import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';

import { Wrapper } from './elements';

type Props = {
  readonly imageSrc: string;
  readonly children?: React.ReactNode;
};

function PodiumWrapper({
  imageSrc,
  children,
}: Props & ConnectedProps): React.ReactElement {
  return <Wrapper imageSrc={imageSrc}>{children}</Wrapper>;
}

export default connect<Props>(PodiumWrapper);
